import './trustedTypes';
import './rsc/installBrowserShim';
import { StrictMode, startTransition, type ErrorInfo } from 'react';
import { hydrateRoot } from 'react-dom/client';
import {
  createFromReadableStream,
  createTemporaryReferenceSet,
} from 'react-server-dom-webpack/client';
import { RSCHydratedRouter, getRSCStream } from './rsc/router';
import { initClientI18n } from './i18n';

const clientCreateFromReadableStream = (stream: ReadableStream<Uint8Array>) =>
  createFromReadableStream(stream, { temporaryReferences: createTemporaryReferenceSet() });

initClientI18n(document.documentElement.lang);
function onRecoverableError(error: unknown, info: ErrorInfo): void {
  const candidate = error as { cause?: unknown; message?: string } | null;
  const cause = candidate?.cause as { [key: symbol]: unknown } | null | undefined;
  if (cause?.[Symbol.for('react.recoverable')] === true || candidate?.message?.includes('browser('))
    return;
  console.error('Website hydration recovered from an error:', error, info);
}
clientCreateFromReadableStream(getRSCStream()).then((payload) => {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <RSCHydratedRouter
          payload={payload as never}
          createFromReadableStream={(stream) =>
            createFromReadableStream(stream, { temporaryReferences: createTemporaryReferenceSet() })
          }
        />
      </StrictMode>,
      { onRecoverableError },
    );
  });
});
